import { GlobalColors, Rules } from 'src/App/Styles/Globals';
import { column, row_center_vertical } from 'src/App/Styles/styles-helpers';
import styled from 'styled-components/macro';

export const LeaderboardItemContain = styled.div`
	${column}
	flex: 1;
	overflow: hidden;
	border-top: 1px solid ${GlobalColors.darkerBox};
	padding-top: 0.5rem;
`;
export const LIListHeader = styled.div`
	display: grid;
	grid-template-columns: 40px 4fr 1fr;
	align-items: center;
	gap: 0.5rem;
	padding: 0 0.5rem;
	padding-bottom: 0.3rem;
	padding-right: 1.2rem;
	font-size: 0.75rem;
	div:nth-of-type(1) {
		justify-self: center;
	}
	@media (max-width: 400px) {
		grid-template-columns: 40px 4fr 1fr;
	}
`;
export const LIList = styled.div`
	${column}
	overflow: auto;
	gap: 0.5rem;
	padding: 0 0.5rem;
	padding-bottom: 1rem;
`;
export const LIListItem = styled(LIListHeader)`
	background-color: ${GlobalColors.darkerBox};
	border-radius: ${Rules.radiusRoundContainer};
	padding: 0.5rem 0;
	min-height: 30px;
`;
export const LIElipsedName = styled.div`
	overflow: hidden;
	word-break: keep-all;
	white-space: nowrap;
	text-overflow: ellipsis;
`;
export const LIAvatarContainer = styled.div`
	border-radius: 50%;
	width: 20px;
	height: 20px;
	overflow: hidden;
	img,
	svg {
		width: 20px;
		height: 20px;
		object-fit: cover;
	}
`;
export const LIRankContainer = styled.div`
	svg {
		width: 20px;
		height: 20px;
	}
`;
export const LIUserContainer = styled.div`
	display: grid;
	grid-template-columns: 20px 1fr;
	align-items: center;
	gap: 0.3rem;
	overflow: hidden;
`;
export const LIUserNameContainer = styled.div`
	overflow: hidden;
	word-break: keep-all;
	white-space: nowrap;
	text-overflow: ellipsis;
`;
export const LIBitsContainer = styled.div`
	${row_center_vertical}
	min-width: 40px;
	gap: 10px;
	padding-right: 0.5rem;
	img {
		height: 15px;
	}
`;
